<template>
  <b-modal
    v-model="visible"
    :title="$t('whatsapp-consent.title')"
    centered
    :busy="busy"
    no-close-on-backdrop
    @hidden="onHidden"
  >
    <p>{{ $t('whatsapp-consent.description') }}</p>
    <p class="small text-muted mb-0">
      {{ $t('whatsapp-consent.revocable') }}
    </p>

    <template #modal-footer>
      <b-button
        variant="outline-secondary"
        :disabled="busy"
        @click="decide(false)"
      >
        {{ $t('whatsapp-consent.decline') }}
      </b-button>
      <b-button variant="primary" :disabled="busy" @click="decide(true)">
        {{ $t('whatsapp-consent.accept') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

/**
 * One-time WhatsApp opt-in dialog (GID-2697, M6).
 *
 * Meta's platform policy requires the recipient's opt-in before GID may send
 * business-initiated WhatsApp messages, independent of the legal basis — so
 * the decision is stored per contact and the send path refuses without it.
 *
 * Shows once per undecided contact after login. Either decision is remembered
 * server-side (accept and decline both), so a contact who answered is never
 * asked again. Closing without answering asks again next session — silence is
 * not consent.
 */
export default {
  name: 'WhatsappConsentModal',
  data() {
    return {
      visible: false,
      busy: false,
      checked: false,
    };
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
  },
  watch: {
    isAuthenticated: {
      immediate: true,
      handler(authenticated) {
        if (authenticated && !this.checked) {
          this.check();
        }
      },
    },
  },
  methods: {
    async check() {
      this.checked = true;
      try {
        const { data } = await axios.get('/data-api/whatsapp-consent');
        if (!data.decided) {
          this.visible = true;
        }
      } catch (error) {
        // No contact record, endpoint not deployed yet, transient failure —
        // never block the app over the consent dialog; we ask again next login.
      }
    },
    async decide(granted) {
      this.busy = true;
      try {
        await axios.post('/data-api/whatsapp-consent', { granted });
        this.visible = false;
      } catch (error) {
        // Keep the dialog open; the user can retry or close it.
      } finally {
        this.busy = false;
      }
    },
    onHidden() {
      // Dismissed without deciding: nothing is stored, next login re-asks.
    },
  },
};
</script>
